import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { ConsensusEventMessage } from "../ExplorerTestPage";
import { ConsensusEventItem } from "./ConsensusEventItem";

interface EventDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  event: ConsensusEventMessage | null;
}

export const EventDetailsModal: React.FC<EventDetailsModalProps> = ({
  isOpen,
  onClose,
  event,
}) => {
  useEffect(() => {
    if (isOpen) {
      // Prevent body scroll when modal is open
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape" && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      window.addEventListener("keydown", handleEscape);
    }

    return () => {
      window.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen || !event) return null;

  // Use React Portal to render modal at document.body level for proper z-index stacking
  return typeof document !== "undefined"
    ? createPortal(
        <div className="event-modal-overlay" onClick={onClose}>
          <div className="event-modal" onClick={(e) => e.stopPropagation()}>
            <div className="event-modal-header">
              <h3 className="event-modal-title">Event Details</h3>
              <button className="event-modal-close-button" onClick={onClose}>
                ×
              </button>
            </div>
            <div className="event-modal-body">
              <ConsensusEventItem message={event} />
            </div>
          </div>
        </div>,
        document.body,
      )
    : null;
};
